export default {
  title: "Invoice",

  input: {
    title: "Edit invoice data",
    titlePaid: "Edit payment date",

    status: "Status",
    invoiceNumberManual: "Manual invoice number",
    invoiceNumber: "Invoice number",
    invoiceDate: "Invoice date",
    dueDate: "Due date",
    reminders: "Reminder due on",
    paidDate: "Paid on",
  },

  olderReminders: "+ {{number}} older ones",
}
